import { PropsWithChildren } from 'react'

/** Restricts the rending of a child only if said value is defined (!== undefined) */
export default function OnlyIf({
  children,
  ifValue,
}: PropsWithChildren<{ ifValue: any | undefined }>) {
  if (ifValue === undefined) return null
  return children
}
